/* eslint-disable max-len */
import {
    Contact,
} from 'app/Apps/ContactManagement/Contacts/Contacts.types'
import {
    SkyDataGridColumnDefinition,
    SkyNetDataGridFilterType,
} from 'app/PoC/DataGridDemoPages/components/SkyBaseDataGrid/SkyBaseDataGrid.types'
import {
    FilterType,
} from 'app/enums/common.enums'

type AdditionalFeesTable = Contact & {
    additionalFeesNumber: string,
    additionalFeesStatus: string,
    validFrom: string,
    validTo: string,
    changedOn: string,
    changedBy: string,
}

const config: SkyDataGridColumnDefinition<AdditionalFeesTable>[] = [
    {
        name: 'additionalFeesNumber',
        labelKey: 'ADDITIONAL_FEE',
    },
    {
        name: 'additionalFeesStatus',
        filterType: FilterType.Array,
        componentName: 'AdditionalFeesStatusEnriched',
        labelKey: 'STATUS',
    },
    {
        name: 'validFrom',
        componentName: 'DateTimeCell',
        filterType: SkyNetDataGridFilterType.TimeLessDateRange,
        labelKey: 'VALID_FROM',
    },
    {
        name: 'validTo',
        componentName: 'LaneDateEnriched',
        filterType: SkyNetDataGridFilterType.TimeLessDateRange,
        labelKey: 'VALID_TO',
    },
    {
        name: 'changedOn',
        componentName: 'DateTimeCell',
        labelKey: 'CHANGED_ON',
    },
    {
        name: 'changedBy',
        labelKey: 'CHANGED_BY',
    },
]

export default config
